
export class PeriodFilter {
  startDate: Date;
  endDate: Date;
  periodSelectorType: number;
  formattedPeriod: string;
}
